import FormComponent from "./FormComponent";

function CreateQuickTenderPage() {
  return (
    <div>
      <FormComponent />
    </div>
  );
}

export default CreateQuickTenderPage;
